module.exports = __webpack_public_path__ + "img/table1.a93acc9a.png";